
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tutorials/[module]",
      function () {
        return require("private-next-pages/tutorials/[module]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tutorials/[module]"])
      });
    }
  